import { Feedback, Tokens } from "@accurx/design";
import styled from "styled-components";

export const StyledFeedback = styled(Feedback)`
    margin-bottom: ${Tokens.SIZES[2]};
`;
